import { Context as e } from "@textile/context";
"undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self && self;
var t,
    n = (function (e, t) {
  e.exports = function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 11);
  }([function (e, t, n) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(4);
    t.Metadata = r.BrowserHeaders;
  }, function (e, t, n) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.debug = function () {
      for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];

      console.debug ? console.debug.apply(null, e) : console.log.apply(null, e);
    };
  }, function (e, t, n) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = null;

    t.default = function (e) {
      null === r ? (r = [e], setTimeout(function () {
        !function e() {
          if (r) {
            var t = r;
            r = null;

            for (var n = 0; n < t.length; n++) try {
              t[n]();
            } catch (s) {
              null === r && (r = [], setTimeout(function () {
                e();
              }, 0));

              for (var o = t.length - 1; o > n; o--) r.unshift(t[o]);

              throw s;
            }
          }
        }();
      }, 0)) : r.push(e);
    };
  }, function (e, t, n) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(0),
        o = n(9),
        s = n(10),
        i = n(1),
        a = n(2),
        u = n(5),
        c = n(15);

    t.client = function (e, t) {
      return new d(e, t);
    };

    var d = function () {
      function e(e, t) {
        this.started = !1, this.sentFirstMessage = !1, this.completed = !1, this.closed = !1, this.finishedSending = !1, this.onHeadersCallbacks = [], this.onMessageCallbacks = [], this.onEndCallbacks = [], this.parser = new o.ChunkParser(), this.methodDefinition = e, this.props = t, this.createTransport();
      }

      return e.prototype.createTransport = function () {
        var e = this.props.host + "/" + this.methodDefinition.service.serviceName + "/" + this.methodDefinition.methodName,
            t = {
          methodDefinition: this.methodDefinition,
          debug: this.props.debug || !1,
          url: e,
          onHeaders: this.onTransportHeaders.bind(this),
          onChunk: this.onTransportChunk.bind(this),
          onEnd: this.onTransportEnd.bind(this)
        };
        this.props.transport ? this.transport = this.props.transport(t) : this.transport = u.makeDefaultTransport(t);
      }, e.prototype.onTransportHeaders = function (e, t) {
        if (this.props.debug && i.debug("onHeaders", e, t), this.closed) this.props.debug && i.debug("grpc.onHeaders received after request was closed - ignoring");else if (0 === t) ;else {
          this.responseHeaders = e, this.props.debug && i.debug("onHeaders.responseHeaders", JSON.stringify(this.responseHeaders, null, 2));
          var n = p(e);
          this.props.debug && i.debug("onHeaders.gRPCStatus", n);
          var r = n && n >= 0 ? n : s.httpStatusToCode(t);
          this.props.debug && i.debug("onHeaders.code", r);
          var o = e.get("grpc-message") || [];

          if (this.props.debug && i.debug("onHeaders.gRPCMessage", o), this.rawOnHeaders(e), r !== s.Code.OK) {
            var a = this.decodeGRPCStatus(o[0]);
            this.rawOnError(r, a, e);
          }
        }
      }, e.prototype.onTransportChunk = function (e) {
        var t = this;
        if (this.closed) this.props.debug && i.debug("grpc.onChunk received after request was closed - ignoring");else {
          var n = [];

          try {
            n = this.parser.parse(e);
          } catch (e) {
            return this.props.debug && i.debug("onChunk.parsing error", e, e.message), void this.rawOnError(s.Code.Internal, "parsing error: " + e.message);
          }

          n.forEach(function (e) {
            if (e.chunkType === o.ChunkType.MESSAGE) {
              var n = t.methodDefinition.responseType.deserializeBinary(e.data);
              t.rawOnMessage(n);
            } else e.chunkType === o.ChunkType.TRAILERS && (t.responseHeaders ? (t.responseTrailers = new r.Metadata(e.trailers), t.props.debug && i.debug("onChunk.trailers", t.responseTrailers)) : (t.responseHeaders = new r.Metadata(e.trailers), t.rawOnHeaders(t.responseHeaders)));
          });
        }
      }, e.prototype.onTransportEnd = function () {
        if (this.props.debug && i.debug("grpc.onEnd"), this.closed) this.props.debug && i.debug("grpc.onEnd received after request was closed - ignoring");else if (void 0 !== this.responseTrailers) {
          var e = p(this.responseTrailers);

          if (null !== e) {
            var t = this.responseTrailers.get("grpc-message"),
                n = this.decodeGRPCStatus(t[0]);
            this.rawOnEnd(e, n, this.responseTrailers);
          } else this.rawOnError(s.Code.Internal, "Response closed without grpc-status (Trailers provided)");
        } else {
          if (void 0 === this.responseHeaders) return void this.rawOnError(s.Code.Unknown, "Response closed without headers");
          var r = p(this.responseHeaders),
              o = this.responseHeaders.get("grpc-message");
          if (this.props.debug && i.debug("grpc.headers only response ", r, o), null === r) return void this.rawOnEnd(s.Code.Unknown, "Response closed without grpc-status (Headers only)", this.responseHeaders);
          var a = this.decodeGRPCStatus(o[0]);
          this.rawOnEnd(r, a, this.responseHeaders);
        }
      }, e.prototype.decodeGRPCStatus = function (e) {
        if (!e) return "";

        try {
          return decodeURIComponent(e);
        } catch (t) {
          return e;
        }
      }, e.prototype.rawOnEnd = function (e, t, n) {
        var r = this;
        this.props.debug && i.debug("rawOnEnd", e, t, n), this.completed || (this.completed = !0, this.onEndCallbacks.forEach(function (o) {
          a.default(function () {
            r.closed || o(e, t, n);
          });
        }));
      }, e.prototype.rawOnHeaders = function (e) {
        this.props.debug && i.debug("rawOnHeaders", e), this.completed || this.onHeadersCallbacks.forEach(function (t) {
          a.default(function () {
            t(e);
          });
        });
      }, e.prototype.rawOnError = function (e, t, n) {
        var o = this;
        void 0 === n && (n = new r.Metadata()), this.props.debug && i.debug("rawOnError", e, t), this.completed || (this.completed = !0, this.onEndCallbacks.forEach(function (r) {
          a.default(function () {
            o.closed || r(e, t, n);
          });
        }));
      }, e.prototype.rawOnMessage = function (e) {
        var t = this;
        this.props.debug && i.debug("rawOnMessage", e.toObject()), this.completed || this.closed || this.onMessageCallbacks.forEach(function (n) {
          a.default(function () {
            t.closed || n(e);
          });
        });
      }, e.prototype.onHeaders = function (e) {
        this.onHeadersCallbacks.push(e);
      }, e.prototype.onMessage = function (e) {
        this.onMessageCallbacks.push(e);
      }, e.prototype.onEnd = function (e) {
        this.onEndCallbacks.push(e);
      }, e.prototype.start = function (e) {
        if (this.started) throw new Error("Client already started - cannot .start()");
        this.started = !0;
        var t = new r.Metadata(e || {});
        t.set("content-type", "application/grpc-web+proto"), t.set("x-grpc-web", "1"), this.transport.start(t);
      }, e.prototype.send = function (e) {
        if (!this.started) throw new Error("Client not started - .start() must be called before .send()");
        if (this.closed) throw new Error("Client already closed - cannot .send()");
        if (this.finishedSending) throw new Error("Client already finished sending - cannot .send()");
        if (!this.methodDefinition.requestStream && this.sentFirstMessage) throw new Error("Message already sent for non-client-streaming method - cannot .send()");
        this.sentFirstMessage = !0;
        var t = c.frameRequest(e);
        this.transport.sendMessage(t);
      }, e.prototype.finishSend = function () {
        if (!this.started) throw new Error("Client not started - .finishSend() must be called before .close()");
        if (this.closed) throw new Error("Client already closed - cannot .send()");
        if (this.finishedSending) throw new Error("Client already finished sending - cannot .finishSend()");
        this.finishedSending = !0, this.transport.finishSend();
      }, e.prototype.close = function () {
        if (!this.started) throw new Error("Client not started - .start() must be called before .close()");
        if (this.closed) throw new Error("Client already closed - cannot .close()");
        this.closed = !0, this.props.debug && i.debug("request.abort aborting request"), this.transport.cancel();
      }, e;
    }();

    function p(e) {
      var t = e.get("grpc-status") || [];
      if (t.length > 0) try {
        var n = t[0];
        return parseInt(n, 10);
      } catch (e) {
        return null;
      }
      return null;
    }
  }, function (e, t, n) {
    var r;
    r = function r() {
      return function (e) {
        var t = {};

        function n(r) {
          if (t[r]) return t[r].exports;
          var o = t[r] = {
            i: r,
            l: !1,
            exports: {}
          };
          return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
        }

        return n.m = e, n.c = t, n.i = function (e) {
          return e;
        }, n.d = function (e, t, r) {
          n.o(e, t) || Object.defineProperty(e, t, {
            configurable: !1,
            enumerable: !0,
            get: r
          });
        }, n.n = function (e) {
          var t = e && e.__esModule ? function () {
            return e.default;
          } : function () {
            return e;
          };
          return n.d(t, "a", t), t;
        }, n.o = function (e, t) {
          return Object.prototype.hasOwnProperty.call(e, t);
        }, n.p = "", n(n.s = 1);
      }([function (e, t, n) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });

        var r = n(3),
            o = function () {
          function e(e, t) {
            void 0 === e && (e = {}), void 0 === t && (t = {
              splitValues: !1
            });
            var n,
                o = this;
            this.headersMap = {}, e && ("undefined" != typeof Headers && e instanceof Headers ? r.getHeaderKeys(e).forEach(function (n) {
              r.getHeaderValues(e, n).forEach(function (e) {
                t.splitValues ? o.append(n, r.splitHeaderValue(e)) : o.append(n, e);
              });
            }) : "object" == typeof (n = e) && "object" == typeof n.headersMap && "function" == typeof n.forEach ? e.forEach(function (e, t) {
              o.append(e, t);
            }) : "undefined" != typeof Map && e instanceof Map ? e.forEach(function (e, t) {
              o.append(t, e);
            }) : "string" == typeof e ? this.appendFromString(e) : "object" == typeof e && Object.getOwnPropertyNames(e).forEach(function (t) {
              var n = e[t];
              Array.isArray(n) ? n.forEach(function (e) {
                o.append(t, e);
              }) : o.append(t, n);
            }));
          }

          return e.prototype.appendFromString = function (e) {
            for (var t = e.split("\r\n"), n = 0; n < t.length; n++) {
              var r = t[n],
                  o = r.indexOf(":");

              if (o > 0) {
                var s = r.substring(0, o).trim(),
                    i = r.substring(o + 1).trim();
                this.append(s, i);
              }
            }
          }, e.prototype.delete = function (e, t) {
            var n = r.normalizeName(e);
            if (void 0 === t) delete this.headersMap[n];else {
              var o = this.headersMap[n];

              if (o) {
                var s = o.indexOf(t);
                s >= 0 && o.splice(s, 1), 0 === o.length && delete this.headersMap[n];
              }
            }
          }, e.prototype.append = function (e, t) {
            var n = this,
                o = r.normalizeName(e);
            Array.isArray(this.headersMap[o]) || (this.headersMap[o] = []), Array.isArray(t) ? t.forEach(function (e) {
              n.headersMap[o].push(r.normalizeValue(e));
            }) : this.headersMap[o].push(r.normalizeValue(t));
          }, e.prototype.set = function (e, t) {
            var n = r.normalizeName(e);

            if (Array.isArray(t)) {
              var o = [];
              t.forEach(function (e) {
                o.push(r.normalizeValue(e));
              }), this.headersMap[n] = o;
            } else this.headersMap[n] = [r.normalizeValue(t)];
          }, e.prototype.has = function (e, t) {
            var n = this.headersMap[r.normalizeName(e)];
            if (!Array.isArray(n)) return !1;

            if (void 0 !== t) {
              var o = r.normalizeValue(t);
              return n.indexOf(o) >= 0;
            }

            return !0;
          }, e.prototype.get = function (e) {
            var t = this.headersMap[r.normalizeName(e)];
            return void 0 !== t ? t.concat() : [];
          }, e.prototype.forEach = function (e) {
            var t = this;
            Object.getOwnPropertyNames(this.headersMap).forEach(function (n) {
              e(n, t.headersMap[n]);
            }, this);
          }, e.prototype.toHeaders = function () {
            if ("undefined" != typeof Headers) {
              var e = new Headers();
              return this.forEach(function (t, n) {
                n.forEach(function (n) {
                  e.append(t, n);
                });
              }), e;
            }

            throw new Error("Headers class is not defined");
          }, e;
        }();

        t.BrowserHeaders = o;
      }, function (e, t, n) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var r = n(0);
        t.BrowserHeaders = r.BrowserHeaders;
      }, function (e, t, n) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.iterateHeaders = function (e, t) {
          for (var n = e[Symbol.iterator](), r = n.next(); !r.done;) t(r.value[0]), r = n.next();
        }, t.iterateHeadersKeys = function (e, t) {
          for (var n = e.keys(), r = n.next(); !r.done;) t(r.value), r = n.next();
        };
      }, function (e, t, n) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var r = n(2);

        function o(e) {
          return e;
        }

        t.normalizeName = function (e) {
          if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(e)) throw new TypeError("Invalid character in header field name");
          return e.toLowerCase();
        }, t.normalizeValue = function (e) {
          return "string" != typeof e && (e = String(e)), e;
        }, t.getHeaderValues = function (e, t) {
          var n = o(e);
          if (n instanceof Headers && n.getAll) return n.getAll(t);
          var r = n.get(t);
          return r && "string" == typeof r ? [r] : r;
        }, t.getHeaderKeys = function (e) {
          var t = o(e),
              n = {},
              s = [];
          return t.keys ? r.iterateHeadersKeys(t, function (e) {
            n[e] || (n[e] = !0, s.push(e));
          }) : t.forEach ? t.forEach(function (e, t) {
            n[t] || (n[t] = !0, s.push(t));
          }) : r.iterateHeaders(t, function (e) {
            var t = e[0];
            n[t] || (n[t] = !0, s.push(t));
          }), s;
        }, t.splitHeaderValue = function (e) {
          var t = [];
          return e.split(", ").forEach(function (e) {
            e.split(",").forEach(function (e) {
              t.push(e);
            });
          }), t;
        };
      }]);
    }, e.exports = r();
  }, function (e, t, n) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = n(6),
        o = function o(e) {
      return r.CrossBrowserHttpTransport({
        withCredentials: !1
      })(e);
    };

    t.setDefaultTransportFactory = function (e) {
      o = e;
    }, t.makeDefaultTransport = function (e) {
      return o(e);
    };
  }, function (e, t, n) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(7),
        o = n(8);

    t.CrossBrowserHttpTransport = function (e) {
      if (r.detectFetchSupport()) {
        var t = {
          credentials: e.withCredentials ? "include" : "same-origin"
        };
        return r.FetchReadableStreamTransport(t);
      }

      return o.XhrTransport({
        withCredentials: e.withCredentials
      });
    };
  }, function (e, t, n) {
    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0),
        s = n(1),
        i = n(2);

    t.FetchReadableStreamTransport = function (e) {
      return function (t) {
        return function (e, t) {
          return e.debug && s.debug("fetchRequest", e), new a(e, t);
        }(t, e);
      };
    };

    var a = function () {
      function e(e, t) {
        this.cancelled = !1, this.controller = self.AbortController && new AbortController(), this.options = e, this.init = t;
      }

      return e.prototype.pump = function (e, t) {
        var n = this;
        if (this.reader = e, this.cancelled) return this.options.debug && s.debug("Fetch.pump.cancel at first pump"), void this.reader.cancel();
        this.reader.read().then(function (e) {
          if (e.done) return i.default(function () {
            n.options.onEnd();
          }), t;
          i.default(function () {
            n.options.onChunk(e.value);
          }), n.pump(n.reader, t);
        }).catch(function (e) {
          n.cancelled ? n.options.debug && s.debug("Fetch.catch - request cancelled") : (n.cancelled = !0, n.options.debug && s.debug("Fetch.catch", e.message), i.default(function () {
            n.options.onEnd(e);
          }));
        });
      }, e.prototype.send = function (e) {
        var t = this;
        fetch(this.options.url, r({}, this.init, {
          headers: this.metadata.toHeaders(),
          method: "POST",
          body: e,
          signal: this.controller && this.controller.signal
        })).then(function (e) {
          if (t.options.debug && s.debug("Fetch.response", e), i.default(function () {
            t.options.onHeaders(new o.Metadata(e.headers), e.status);
          }), !e.body) return e;
          t.pump(e.body.getReader(), e);
        }).catch(function (e) {
          t.cancelled ? t.options.debug && s.debug("Fetch.catch - request cancelled") : (t.cancelled = !0, t.options.debug && s.debug("Fetch.catch", e.message), i.default(function () {
            t.options.onEnd(e);
          }));
        });
      }, e.prototype.sendMessage = function (e) {
        this.send(e);
      }, e.prototype.finishSend = function () {}, e.prototype.start = function (e) {
        this.metadata = e;
      }, e.prototype.cancel = function () {
        this.cancelled ? this.options.debug && s.debug("Fetch.abort.cancel already cancelled") : (this.cancelled = !0, this.reader ? (this.options.debug && s.debug("Fetch.abort.cancel"), this.reader.cancel()) : this.options.debug && s.debug("Fetch.abort.cancel before reader"), this.controller && this.controller.abort());
      }, e;
    }();

    t.detectFetchSupport = function () {
      return "undefined" != typeof Response && Response.prototype.hasOwnProperty("body") && "function" == typeof Headers;
    };
  }, function (e, t, n) {
    var _r,
        o = this && this.__extends || (_r = function r(e, t) {
      return (_r = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = n(0),
        i = n(1),
        a = n(2),
        u = n(12);

    t.XhrTransport = function (e) {
      return function (t) {
        if (u.detectMozXHRSupport()) return new d(t, e);
        if (u.detectXHROverrideMimeTypeSupport()) return new c(t, e);
        throw new Error("This environment's XHR implementation cannot support binary transfer.");
      };
    };

    var c = function () {
      function e(e, t) {
        this.options = e, this.init = t;
      }

      return e.prototype.onProgressEvent = function () {
        var e = this;
        this.options.debug && i.debug("XHR.onProgressEvent.length: ", this.xhr.response.length);
        var t = this.xhr.response.substr(this.index);
        this.index = this.xhr.response.length;
        var n = f(t);
        a.default(function () {
          e.options.onChunk(n);
        });
      }, e.prototype.onLoadEvent = function () {
        var e = this;
        this.options.debug && i.debug("XHR.onLoadEvent"), a.default(function () {
          e.options.onEnd();
        });
      }, e.prototype.onStateChange = function () {
        var e = this;
        this.options.debug && i.debug("XHR.onStateChange", this.xhr.readyState), this.xhr.readyState === XMLHttpRequest.HEADERS_RECEIVED && a.default(function () {
          e.options.onHeaders(new s.Metadata(e.xhr.getAllResponseHeaders()), e.xhr.status);
        });
      }, e.prototype.sendMessage = function (e) {
        this.xhr.send(e);
      }, e.prototype.finishSend = function () {}, e.prototype.start = function (e) {
        var t = this;
        this.metadata = e;
        var n = new XMLHttpRequest();
        this.xhr = n, n.open("POST", this.options.url), this.configureXhr(), this.metadata.forEach(function (e, t) {
          n.setRequestHeader(e, t.join(", "));
        }), n.withCredentials = Boolean(this.init.withCredentials), n.addEventListener("readystatechange", this.onStateChange.bind(this)), n.addEventListener("progress", this.onProgressEvent.bind(this)), n.addEventListener("loadend", this.onLoadEvent.bind(this)), n.addEventListener("error", function (e) {
          t.options.debug && i.debug("XHR.error", e), a.default(function () {
            t.options.onEnd(e.error);
          });
        });
      }, e.prototype.configureXhr = function () {
        this.xhr.responseType = "text", this.xhr.overrideMimeType("text/plain; charset=x-user-defined");
      }, e.prototype.cancel = function () {
        this.options.debug && i.debug("XHR.abort"), this.xhr.abort();
      }, e;
    }();

    t.XHR = c;

    var d = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.configureXhr = function () {
        this.options.debug && i.debug("MozXHR.configureXhr: setting responseType to 'moz-chunked-arraybuffer'"), this.xhr.responseType = "moz-chunked-arraybuffer";
      }, t.prototype.onProgressEvent = function () {
        var e = this,
            t = this.xhr.response;
        this.options.debug && i.debug("MozXHR.onProgressEvent: ", new Uint8Array(t)), a.default(function () {
          e.options.onChunk(new Uint8Array(t));
        });
      }, t;
    }(c);

    function p(e, t) {
      var n = e.charCodeAt(t);

      if (n >= 55296 && n <= 56319) {
        var r = e.charCodeAt(t + 1);
        r >= 56320 && r <= 57343 && (n = 65536 + (n - 55296 << 10) + (r - 56320));
      }

      return n;
    }

    function f(e) {
      for (var t = new Uint8Array(e.length), n = 0, r = 0; r < e.length; r++) {
        var o = String.prototype.codePointAt ? e.codePointAt(r) : p(e, r);
        t[n++] = 255 & o;
      }

      return t;
    }

    t.MozChunkedArrayBufferXHR = d, t.stringToArrayBuffer = f;
  }, function (e, t, n) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r,
        o = n(0),
        s = function s(e) {
      return 9 === e || 10 === e || 13 === e;
    };

    function i(e) {
      return s(e) || e >= 32 && e <= 126;
    }

    function a(e) {
      for (var t = 0; t !== e.length; ++t) if (!i(e[t])) throw new Error("Metadata is not valid (printable) ASCII");

      return String.fromCharCode.apply(String, Array.prototype.slice.call(e));
    }

    function u(e) {
      return 128 == (128 & e.getUint8(0));
    }

    function c(e) {
      return e.getUint32(1, !1);
    }

    function d(e, t, n) {
      return e.byteLength - t >= n;
    }

    function p(e, t, n) {
      if (e.slice) return e.slice(t, n);
      var r = e.length;
      void 0 !== n && (r = n);

      for (var o = new Uint8Array(r - t), s = 0, i = t; i < r; i++) o[s++] = e[i];

      return o;
    }

    t.decodeASCII = a, t.encodeASCII = function (e) {
      for (var t = new Uint8Array(e.length), n = 0; n !== e.length; ++n) {
        var r = e.charCodeAt(n);
        if (!i(r)) throw new Error("Metadata contains invalid ASCII");
        t[n] = r;
      }

      return t;
    }, function (e) {
      e[e.MESSAGE = 1] = "MESSAGE", e[e.TRAILERS = 2] = "TRAILERS";
    }(r = t.ChunkType || (t.ChunkType = {}));

    var f = function () {
      function e() {
        this.buffer = null, this.position = 0;
      }

      return e.prototype.parse = function (e, t) {
        if (0 === e.length && t) return [];
        var n,
            s = [];
        if (null == this.buffer) this.buffer = e, this.position = 0;else if (this.position === this.buffer.byteLength) this.buffer = e, this.position = 0;else {
          var i = this.buffer.byteLength - this.position,
              f = new Uint8Array(i + e.byteLength),
              l = p(this.buffer, this.position);
          f.set(l, 0);
          var h = new Uint8Array(e);
          f.set(h, i), this.buffer = f, this.position = 0;
        }

        for (;;) {
          if (!d(this.buffer, this.position, 5)) return s;
          var g = p(this.buffer, this.position, this.position + 5),
              b = new DataView(g.buffer, g.byteOffset, g.byteLength),
              y = c(b);
          if (!d(this.buffer, this.position, 5 + y)) return s;
          var v = p(this.buffer, this.position + 5, this.position + 5 + y);
          if (this.position += 5 + y, u(b)) return s.push({
            chunkType: r.TRAILERS,
            trailers: (n = v, new o.Metadata(a(n)))
          }), s;
          s.push({
            chunkType: r.MESSAGE,
            data: v
          });
        }
      }, e;
    }();

    t.ChunkParser = f;
  }, function (e, t, n) {
    var r;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.OK = 0] = "OK", e[e.Canceled = 1] = "Canceled", e[e.Unknown = 2] = "Unknown", e[e.InvalidArgument = 3] = "InvalidArgument", e[e.DeadlineExceeded = 4] = "DeadlineExceeded", e[e.NotFound = 5] = "NotFound", e[e.AlreadyExists = 6] = "AlreadyExists", e[e.PermissionDenied = 7] = "PermissionDenied", e[e.ResourceExhausted = 8] = "ResourceExhausted", e[e.FailedPrecondition = 9] = "FailedPrecondition", e[e.Aborted = 10] = "Aborted", e[e.OutOfRange = 11] = "OutOfRange", e[e.Unimplemented = 12] = "Unimplemented", e[e.Internal = 13] = "Internal", e[e.Unavailable = 14] = "Unavailable", e[e.DataLoss = 15] = "DataLoss", e[e.Unauthenticated = 16] = "Unauthenticated";
    }(r = t.Code || (t.Code = {})), t.httpStatusToCode = function (e) {
      switch (e) {
        case 0:
          return r.Internal;

        case 200:
          return r.OK;

        case 400:
          return r.InvalidArgument;

        case 401:
          return r.Unauthenticated;

        case 403:
          return r.PermissionDenied;

        case 404:
          return r.NotFound;

        case 409:
          return r.Aborted;

        case 412:
          return r.FailedPrecondition;

        case 429:
          return r.ResourceExhausted;

        case 499:
          return r.Canceled;

        case 500:
          return r.Unknown;

        case 501:
          return r.Unimplemented;

        case 503:
          return r.Unavailable;

        case 504:
          return r.DeadlineExceeded;

        default:
          return r.Unknown;
      }
    };
  }, function (e, t, n) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(4),
        o = n(5),
        s = n(7),
        i = n(13),
        a = n(8),
        u = n(6),
        c = n(10),
        d = n(14),
        p = n(16),
        f = n(3);
    !function (e) {
      e.setDefaultTransport = o.setDefaultTransportFactory, e.CrossBrowserHttpTransport = u.CrossBrowserHttpTransport, e.FetchReadableStreamTransport = s.FetchReadableStreamTransport, e.XhrTransport = a.XhrTransport, e.WebsocketTransport = i.WebsocketTransport, e.Code = c.Code, e.Metadata = r.BrowserHeaders, e.client = function (e, t) {
        return f.client(e, t);
      }, e.invoke = d.invoke, e.unary = p.unary;
    }(t.grpc || (t.grpc = {}));
  }, function (e, t, n) {
    var r;

    function o() {
      if (void 0 !== r) return r;

      if (XMLHttpRequest) {
        r = new XMLHttpRequest();

        try {
          r.open("GET", "https://localhost");
        } catch (e) {}
      }

      return r;
    }

    function s(e) {
      var t = o();
      if (!t) return !1;

      try {
        return t.responseType = e, t.responseType === e;
      } catch (e) {}

      return !1;
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.xhrSupportsResponseType = s, t.detectMozXHRSupport = function () {
      return "undefined" != typeof XMLHttpRequest && s("moz-chunked-arraybuffer");
    }, t.detectXHROverrideMimeTypeSupport = function () {
      return "undefined" != typeof XMLHttpRequest && XMLHttpRequest.prototype.hasOwnProperty("overrideMimeType");
    };
  }, function (e, t, n) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r,
        o = n(1),
        s = n(2),
        i = n(9);
    !function (e) {
      e[e.FINISH_SEND = 1] = "FINISH_SEND";
    }(r || (r = {}));
    var a = new Uint8Array([1]);

    t.WebsocketTransport = function () {
      return function (e) {
        return function (e) {
          e.debug && o.debug("websocketRequest", e);

          var t,
              n = function (e) {
            if ("https://" === e.substr(0, 8)) return "wss://" + e.substr(8);
            if ("http://" === e.substr(0, 7)) return "ws://" + e.substr(7);
            throw new Error("Websocket transport constructed with non-https:// or http:// host.");
          }(e.url),
              u = [];

          function c(e) {
            if (e === r.FINISH_SEND) t.send(a);else {
              var n = e,
                  o = new Int8Array(n.byteLength + 1);
              o.set(new Uint8Array([0])), o.set(n, 1), t.send(o);
            }
          }

          return {
            sendMessage: function sendMessage(e) {
              t && t.readyState !== t.CONNECTING ? c(e) : u.push(e);
            },
            finishSend: function finishSend() {
              t && t.readyState !== t.CONNECTING ? c(r.FINISH_SEND) : u.push(r.FINISH_SEND);
            },
            start: function start(r) {
              (t = new WebSocket(n, ["grpc-websockets"])).binaryType = "arraybuffer", t.onopen = function () {
                var n;
                e.debug && o.debug("websocketRequest.onopen"), t.send((n = "", r.forEach(function (e, t) {
                  n += e + ": " + t.join(", ") + "\r\n";
                }), i.encodeASCII(n))), u.forEach(function (e) {
                  c(e);
                });
              }, t.onclose = function (t) {
                e.debug && o.debug("websocketRequest.onclose", t), s.default(function () {
                  e.onEnd();
                });
              }, t.onerror = function (t) {
                e.debug && o.debug("websocketRequest.onerror", t);
              }, t.onmessage = function (t) {
                s.default(function () {
                  e.onChunk(new Uint8Array(t.data));
                });
              };
            },
            cancel: function cancel() {
              e.debug && o.debug("websocket.abort"), s.default(function () {
                t.close();
              });
            }
          };
        }(e);
      };
    };
  }, function (e, t, n) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(3);

    t.invoke = function (e, t) {
      if (e.requestStream) throw new Error(".invoke cannot be used with client-streaming methods. Use .client instead.");
      var n = r.client(e, {
        host: t.host,
        transport: t.transport,
        debug: t.debug
      });
      return t.onHeaders && n.onHeaders(t.onHeaders), t.onMessage && n.onMessage(t.onMessage), t.onEnd && n.onEnd(t.onEnd), n.start(t.metadata), n.send(t.request), n.finishSend(), {
        close: function close() {
          n.close();
        }
      };
    };
  }, function (e, t, n) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.frameRequest = function (e) {
      var t = e.serializeBinary(),
          n = new ArrayBuffer(t.byteLength + 5);
      return new DataView(n, 1, 4).setUint32(0, t.length, !1), new Uint8Array(n, 5).set(t), new Uint8Array(n);
    };
  }, function (e, t, n) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(0),
        o = n(3);

    t.unary = function (e, t) {
      if (e.responseStream) throw new Error(".unary cannot be used with server-streaming methods. Use .invoke or .client instead.");
      if (e.requestStream) throw new Error(".unary cannot be used with client-streaming methods. Use .client instead.");
      var n = null,
          s = null,
          i = o.client(e, {
        host: t.host,
        transport: t.transport,
        debug: t.debug
      });
      return i.onHeaders(function (e) {
        n = e;
      }), i.onMessage(function (e) {
        s = e;
      }), i.onEnd(function (e, o, i) {
        t.onEnd({
          status: e,
          statusMessage: o,
          headers: n || new r.Metadata(),
          message: s,
          trailers: i
        });
      }), i.start(t.metadata), i.send(t.request), i.finishSend(), {
        close: function close() {
          i.close();
        }
      };
    };
  }]);
}(t = {
  exports: {}
}, t.exports), t.exports),
    r = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {},
    o = null;
"undefined" != typeof WebSocket ? o = WebSocket : "undefined" != typeof MozWebSocket ? o = MozWebSocket : void 0 !== r ? o = r.WebSocket || r.MozWebSocket : "undefined" != typeof window ? o = window.WebSocket || window.MozWebSocket : "undefined" != typeof self && (o = self.WebSocket || self.MozWebSocket);
var s,
    i = o,
    a = (function (e) {
  var t, n;
  t = r, n = function n() {
    var e = function e() {},
        t = "undefined",
        n = typeof window !== t && typeof window.navigator !== t && /Trident\/|MSIE /.test(window.navigator.userAgent),
        r = ["trace", "debug", "info", "warn", "error"];

    function o(e, t) {
      var n = e[t];
      if ("function" == typeof n.bind) return n.bind(e);

      try {
        return Function.prototype.bind.call(n, e);
      } catch (t) {
        return function () {
          return Function.prototype.apply.apply(n, [e, arguments]);
        };
      }
    }

    function s() {
      console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
    }

    function i(r) {
      return "debug" === r && (r = "log"), typeof console !== t && ("trace" === r && n ? s : void 0 !== console[r] ? o(console, r) : void 0 !== console.log ? o(console, "log") : e);
    }

    function a(t, n) {
      for (var o = 0; o < r.length; o++) {
        var s = r[o];
        this[s] = o < t ? e : this.methodFactory(s, t, n);
      }

      this.log = this.debug;
    }

    function u(e, n, r) {
      return function () {
        typeof console !== t && (a.call(this, n, r), this[e].apply(this, arguments));
      };
    }

    function c(e, t, n) {
      return i(e) || u.apply(this, arguments);
    }

    function d(e, n, o) {
      var s,
          i = this,
          u = "loglevel";

      function d() {
        var e;

        if (typeof window !== t && u) {
          try {
            e = window.localStorage[u];
          } catch (e) {}

          if (typeof e === t) try {
            var n = window.document.cookie,
                r = n.indexOf(encodeURIComponent(u) + "=");
            -1 !== r && (e = /^([^;]+)/.exec(n.slice(r))[1]);
          } catch (e) {}
          return void 0 === i.levels[e] && (e = void 0), e;
        }
      }

      "string" == typeof e ? u += ":" + e : "symbol" == typeof e && (u = void 0), i.name = e, i.levels = {
        TRACE: 0,
        DEBUG: 1,
        INFO: 2,
        WARN: 3,
        ERROR: 4,
        SILENT: 5
      }, i.methodFactory = o || c, i.getLevel = function () {
        return s;
      }, i.setLevel = function (n, o) {
        if ("string" == typeof n && void 0 !== i.levels[n.toUpperCase()] && (n = i.levels[n.toUpperCase()]), !("number" == typeof n && n >= 0 && n <= i.levels.SILENT)) throw "log.setLevel() called with invalid level: " + n;
        if (s = n, !1 !== o && function (e) {
          var n = (r[e] || "silent").toUpperCase();

          if (typeof window !== t && u) {
            try {
              return void (window.localStorage[u] = n);
            } catch (e) {}

            try {
              window.document.cookie = encodeURIComponent(u) + "=" + n + ";";
            } catch (e) {}
          }
        }(n), a.call(i, n, e), typeof console === t && n < i.levels.SILENT) return "No console available for logging";
      }, i.setDefaultLevel = function (e) {
        d() || i.setLevel(e, !1);
      }, i.enableAll = function (e) {
        i.setLevel(i.levels.TRACE, e);
      }, i.disableAll = function (e) {
        i.setLevel(i.levels.SILENT, e);
      };
      var p = d();
      null == p && (p = null == n ? "WARN" : n), i.setLevel(p, !1);
    }

    var p = new d(),
        f = {};

    p.getLogger = function (e) {
      if ("symbol" != typeof e && "string" != typeof e || "" === e) throw new TypeError("You must supply a name when creating a logger.");
      var t = f[e];
      return t || (t = f[e] = new d(e, p.getLevel(), p.methodFactory)), t;
    };

    var l = typeof window !== t ? window.log : void 0;
    return p.noConflict = function () {
      return typeof window !== t && window.log === p && (window.log = l), p;
    }, p.getLoggers = function () {
      return f;
    }, p.default = p, p;
  }, e.exports ? e.exports = n() : t.log = n();
}(s = {
  exports: {}
}), s.exports);

const _a$getLogger = a.getLogger("grpc-transport"),
      u = _a$getLogger.debug;

var c;
!function (e) {
  e[e.FINISH_SEND = 1] = "FINISH_SEND";
}(c || (c = {}));
const d = new Uint8Array([1]);

function p(e) {
  e.debug && u("websocketRequest", e);

  const t = function (e) {
    if ("https://" === e.substr(0, 8)) return "wss://".concat(e.substr(8));
    if (e.startsWith("wss://")) return e;
    if ("http://" === e.substr(0, 7)) return "ws://".concat(e.substr(7));
    if (e.startsWith("ws://")) return e;
    throw new Error("Websocket transport constructed with non-{http,ws}[s]:// host.");
  }(e.url),
        n = [];

  let r;

  function o(e) {
    if (e === c.FINISH_SEND) r.send(d);else {
      const t = e,
            n = new Int8Array(t.byteLength + 1);
      n.set(new Uint8Array([0])), n.set(t, 1), r.send(n);
    }
  }

  return {
    sendMessage: e => {
      r && r.readyState !== r.CONNECTING ? o(e) : n.push(e);
    },
    finishSend: () => {
      r && r.readyState !== r.CONNECTING ? o(c.FINISH_SEND) : n.push(c.FINISH_SEND);
    },
    start: s => {
      r = new i(t, ["grpc-websockets"]), r.binaryType = "arraybuffer", r.onopen = function () {
        e.debug && u("websocketRequest.onopen"), r.send(function (e) {
          let t = "";
          return e.forEach((e, n) => {
            t += "".concat(e, ": ").concat(n.join(", "), "\r\n");
          }), function (e) {
            const t = new Uint8Array(e.length);

            for (let o = 0; o !== e.length; ++o) {
              const s = e.charCodeAt(o);
              if (!(9 === (r = n = s) || 10 === r || 13 === r || n >= 32 && n <= 126)) throw new Error("Metadata contains invalid ASCII");
              t[o] = s;
            }

            var n, r;
            return t;
          }(t);
        }(s)), n.forEach(e => {
          o(e);
        });
      }, r.onclose = function (t) {
        e.debug && u("websocketRequest.onclose", t), e.onEnd();
      }, r.onerror = function (t) {
        e.debug && u("websocketRequest.onerror", t);
      }, r.onmessage = function (t) {
        e.onChunk(new Uint8Array(t.data));
      };
    },
    cancel: () => {
      e.debug && u("websocket.abort"), r.close();
    }
  };
}

class f {
  constructor(t = new e(), r = !1) {
    this.context = t;

    const o = e => p(e);

    this.serviceHost = t.host, this.rpcOptions = {
      transport: o,
      debug: r
    }, n.grpc.setDefaultTransport(o);
  }

  unary(e, t, r) {
    return new Promise((o, s) => {
      const i = r ? Object.assign({}, r.toJSON()) : Object.assign({}, this.context.toJSON());
      n.grpc.unary(e, {
        request: t,
        host: this.serviceHost,
        transport: this.rpcOptions.transport,
        debug: this.rpcOptions.debug,
        metadata: i,
        onEnd: e => {
          const t = e.status,
                r = e.statusMessage,
                a = e.message;
          if (t === n.grpc.Code.OK) o(a);else {
            s({
              message: r,
              code: t,
              metadata: i
            });
          }
        }
      });
    });
  }

}

export { f as GrpcConnection };